/**
 * Site header — Alpine component (search, cart count, mobile menu, cart drawer toggle).
 * Extracted from sections/header.liquid.
 *
 * Initial cart values and route URLs are passed via data-* attributes on the
 * <header> root: data-cart-item-count, data-cart-total-price, data-search-url,
 * data-root-url.
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('header', () => ({
    query: '',
    hasResults: false,
    headerHeight: 0,
    mobileMq: window.matchMedia('(min-width: 640px'),
    tabletMq: window.matchMedia('(min-width: 768px)'),
    isMobile: false,
    isTablet: false,
    showMobileSearch: false,
    mobileMenuOpen: false,
    showCartDrawer: false,
    searchOpen: false,
    searchUrl: '',
    rootUrl: '',
    cart: {
      itemCount: 0,
      totalPrice: 0,
    },
    init() {
      const d = this.$el.dataset;
      this.searchUrl = d.searchUrl || '';
      this.rootUrl = d.rootUrl || '';
      this.cart.itemCount = Number(d.cartItemCount) || 0;
      this.cart.totalPrice = Number(d.cartTotalPrice) || 0;

      this.mqHandler();

      window.addEventListener('resize', () => {
        this.mqHandler();
      });

      this.$watch('$store.cartDrawerStore.cart', (cart) => {
        this.cart.itemCount = cart.item_count ? cart.item_count : 0;
        this.cart.totalPrice = cart.total_price ? cart.total_price : 0;
      });

      const header = document.querySelector('header');
      if (header) {
        this.headerHeight = header.offsetHeight;
      }
    },
    toggleSearch() {
      if (this.searchOpen) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    },
    closeSearch() {
      this.searchOpen = false;
      this.resetSearch();
    },
    openSearch() {
      this.searchOpen = true;
      this.resetSearch();
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    resetSearch() {
      this.query = '';
      this.hasResults = false;
      document.getElementById('predictive-search-results-container').innerHTML = '';
    },
    mqHandler() {
      this.isMobile = !this.mobileMq.matches;
      this.isTablet = !this.tabletMq.matches;

      if (!this.isMobile) {
        this.showMobileSearch = false;
        this.mobileMenuOpen = false;
      }
    },
    toggleMobileSearch() {
      this.showMobileSearch = !this.showMobileSearch;

      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    toggleMobileMenu() {
      this.showMobileSearch = false;
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    toggleCartDrawer() {
      this.showMobileSearch = false;

      window.Alpine.store('cartDrawerStore').cartDrawOpen
        ? window.Alpine.store('cartDrawerStore').close()
        : window.Alpine.store('cartDrawerStore').open();
    },
    submitSearch() {
      if (this.query.trim() !== '') {
        window.location.href = `${this.searchUrl}?q=${encodeURIComponent(this.query)}`;
      }
    },
    fetchResults() {
      if (this.query.length < 2) {
        this.hasResults = false;
        document.getElementById('predictive-search-results-container').innerHTML = '';
        return;
      }
      fetch(
        `${this.rootUrl}search/suggest?q=${encodeURIComponent(
          this.query,
        )}&resources[type]=product,page,article,collection&section_id=predictive-search`,
      )
        .then((response) => response.text())
        .then((html) => {
          document.getElementById('predictive-search-results-container').innerHTML = html;
          this.hasResults = true;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
          document.getElementById('predictive-search-results-container').innerHTML =
            '<div class="p-4 text-center text-gray-500">Error loading results</div>';
          this.hasResults = false;
        });
    },
  }));
});
